export default __webpack_public_path__ + "static/media/beerGlassTransparentBG.f3ce1981.svg";